if (!customElements.get('slick-component')) {
  const jqueryScript= document.createElement("script");
  jqueryScript.src= "//ca.mindfulsouls.com/cdn/shop/t/4/assets/jquery.js?45073";
  jqueryScript.defer= true;
  const slickScript= document.createElement("script");
  slickScript.src= "//ca.mindfulsouls.com/cdn/shop/t/4/assets/slick.js?v=1202244967117414591695215233";
  slickScript.defer= true;

  const slickCss= document.createElement("link");
  slickCss.href= "//ca.mindfulsouls.com/cdn/shop/t/4/assets/slick.css?v=69806865747645459931695215232";
  slickCss.rel= "stylesheet";
  slickCss.type= "text/css";

  window.addEventListener("jquery-loaded", (e)=> {
    document.body.appendChild(slickCss)
    document.body.appendChild(slickScript)
    window.addEventListener("slick-loaded", (e)=> {
      document.querySelectorAll("slick-component").forEach(slider=> slider.initSlider())
      window.removeEventListener("slick-loaded", e)
    }, { capture: true, once: true })
    window.removeEventListener("jquery-loaded", e)
  }, { once: true });

  window.jQuery ? window.dispatchEvent(new Event("jquery-loaded")) : document.body.appendChild(jqueryScript)
  customElements.define('slick-component', class SlickComponent extends HTMLElement {
    constructor() {
      super()
      this.slickObj= {mobileFirst: true};
      this.breakpoints=  this.getAttribute("breakpoints").split("|").map(breakpoint => breakpoint.split("-"));
      const attributes= Object.values(this.attributes).filter(attribute => attribute.name.includes("slick-")).map(attribute => {
        attribute.slick_name = attribute.name.split("slick-")[1].replace(/(_\w)/g, m => m[1].toUpperCase());
        if (attribute.value.includes("|")) return attribute;
        this.slickObj[attribute.slick_name]= isNaN(attribute.value) ? /^(true|false)$/i.test(attribute.value) ? (attribute.value === "true") : attribute.value : Number(attribute.value)
      }).filter(attribute => !!attribute)
      this.slickObj.responsive= this.breakpoints.map((breakpoint, index) => { return {
        breakpoint: breakpoint[0],
        settings: breakpoint[1]=='slick'? Object.assign({}, ...attributes.map(attribute=> {
          return { [attribute.slick_name]: isNaN(attribute.value.split("|")[index]) ? /^(true|false)$/i.test(attribute.value.split("|")[index]) ? (attribute.value.split("|")[index] === "true") : attribute.value.split("|")[index] : Number(attribute.value.split("|")[index]) }
        })):"unslick"
      }})

      if(window.design_mode && 'jQuery' in window && typeof $.fn.slick !== "undefined") this.initSlider(true)
    }

    initSlider() {
      $(this).slick(this.slickObj);
      if (!window.design_mode && this.breakpoints.length > 1 && this.getAttribute("breakpoints") && this.getAttribute("breakpoints").includes("unslick")){
        if(this.slick.unslicked){
          window.addEventListener("resize", this.reinitSlider.bind(this))
        }else{
          $(this).on('destroy', function(event, slick){
            window.addEventListener("resize", this.reinitSlider.bind(this))
          })
        }
      }
    }
    
    reinitSlider(){
      const activeBreakpoint= this.slick.activeBreakpoint
      if(this.slick.breakpoints.find(breakpoint=> breakpoint!=activeBreakpoint && Number(breakpoint) <= window.innerWidth)){
        this.initSlider(true)
      }
    }

  })
}
